/* eslint-disable complexity */
import * as React from "react";
import { Layout, Button, Text } from "@draftkings/arena-web";
import { SportsbookContext } from "../../contexts";
export const EarlyExitBadge = React.memo(function EarlyExitBadge(props) {
    const { label, isActive, messages, variant = "earlyExit", testId = "early-exit-badge" } = props;
    const { openEarlyExitTagModal } = React.useContext(SportsbookContext);
    return React.createElement(Layout, { variant: variant },
        React.createElement(Button, { testId: testId, variant: `earlyExit${isActive ? "" : ":Inactive"}`, onClick: openEarlyExitTagModal }, label),
        messages.map((message, index) => (React.createElement(Text, { key: `message-${message}-${index}`, testId: `message-${index}`, variant: "earlyExitMessage" }, message))));
});
//# sourceMappingURL=EarlyExitBadge.js.map